import React, { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import Editor from "../../../../../components/editor";

const TicketChat = ({ SSOData, socket, activeTicket, messages }) => {
  const [newMessage, setNewMessage] = useState("");
  const messagesEndRef = useRef(null);

  // ✅ Auto-scroll
  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [messages, activeTicket]);

  // ✅ Send Message
  const handleSendMessage = (e) => {
    e.preventDefault();
    if (!newMessage.trim() || !activeTicket) return;

    socket?.emit("sendMessage", {
      companyId: SSOData?.companyId,
      userId: SSOData?.userId,
      email: SSOData?.email,
      ticket_id: activeTicket.ticket_id,
      ticketRefId: activeTicket._id,
      sender: "User",
      text: newMessage,
      id: `${socket.id}${Math.random()}`,
      socketID: socket.id,
    });

    setNewMessage("");
  };

  const ticketMessages = activeTicket
    ? messages.filter((msg) => msg.ticket_id === activeTicket.ticket_id)
    : [];

  if (!activeTicket) {
    return (
      <div className="d-flex justify-content-center align-items-center h-100">
        <p className="text-muted">Select a ticket to view conversation</p>
      </div>
    );
  }

  return (
    <>
      {/* Header */}
      <div className="card-header d-flex align-items-center">
        <img
          src={activeTicket.appRefId?.appImage}
          alt={activeTicket.appRefId?.appName}
          className="me-3 rounded"
          style={{ width: "60px", height: "60px", objectFit: "cover" }}
        />
        <div>
          <h5 className="mb-1">{activeTicket.appRefId?.appName}</h5>
          <p className="mb-0 text-muted small">
            Ticket ID: <strong>{activeTicket.ticket_id}</strong>
          </p>
          <span
            className={`badge ${
              activeTicket.status === "open" ? "bg-success" : "bg-danger"
            }`}
          >
            {activeTicket.status.toUpperCase()}
          </span>
        </div>
      </div>

      {/* Conversation */}
      <div
        className="chat-message-list p-3"
        style={{ maxHeight: "65vh", overflowY: "auto", background: "#f9fafb" }}
      >
        {ticketMessages.map((msg, i) => {
          const isSupport = msg.sender === "Support";
          return (
            <div
              key={msg._id || i}
              className={`d-flex mb-4 ${
                isSupport
                  ? "align-items-start"
                  : "flex-row-reverse align-items-start"
              }`}
            >
              {/* Avatar */}
              <div className="me-2 ms-2">
                <Icon
                  icon={isSupport ? "mdi:headset" : "mdi:account-circle"}
                  className={`fs-2 ${
                    isSupport ? "text-secondary" : "text-primary"
                  }`}
                />
              </div>

              {/* Message */}
              <div style={{ maxWidth: "70%" }}>
                <small className="fw-bold text-muted">
                  {isSupport ? "Support" : "You"}
                </small>
                <div
                  className={`p-3 rounded-4 shadow-sm ${
                    isSupport ? "bg-light text-dark" : "bg-primary text-white"
                  }`}
                >
                  <div dangerouslySetInnerHTML={{ __html: msg.text }} />
                </div>
                <div className={isSupport ? "text-start" : "text-end"}>
                  <small className="text-muted">
                    {new Date(msg.createdAt).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </small>
                </div>
              </div>
            </div>
          );
        })}
        <div ref={messagesEndRef}></div>
      </div>

      {/* Reply box */}
      {activeTicket.status === "closed" ? (
        <div className="p-3 border-top bg-light text-center">
          <p className="text-muted mb-0">
            This ticket is <strong>closed</strong>. You can only view previous
            messages.
          </p>
        </div>
      ) : (
        <form
          className="chat-message-box p-3 border-top bg-white shadow-sm"
          onSubmit={handleSendMessage}
        >
          <div className="w-100">
            <Editor
              data={newMessage}
              handleChange={(value) => setNewMessage(value)}
            />
          </div>
          <div className="d-flex align-items-center justify-content-end w-100 mt-2">
            <button
              type="submit"
              className="btn btn-primary rounded-circle shadow-sm"
              style={{ width: "50px", height: "50px" }}
            >
              <Icon icon="f7:paperplane" className="fs-5" />
            </button>
          </div>
        </form>
      )}
    </>
  );
};

export default TicketChat;
